interface BookmarkIconProps {
  filled: boolean;
  size?: number;
}

export function BookmarkIcon({ filled, size = 18 }: BookmarkIconProps) {
  return (
    <svg
      className={`bookmark-icon ${filled ? 'is-filled' : ''}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
    </svg>
  );
}
